// Exports
export default {
	"AvatarBlock": "AvatarBlock_dvP2b",
	"AvatarBlock_small": "AvatarBlock_small_-tc9-",
	"Avatar": "Avatar_++7Dj",
	"Avatar_hidden": "Avatar_hidden_Yp5Bj",
	"Avatar_isPending": "Avatar_isPending_nyVuj",
	"Avatar__pendingIndicator": "Avatar__pendingIndicator_76g7y",
	"participantIcon": "participantIcon_I+bK5"
};
